<div class="d-inline-flex flex-nowrap input-group">
  <span *ngIf="props.prependText" [ngClass]="props.prependTextClass || 'input-group-text'">{{
    props.prependText
  }}</span>

  <button
    *ngIf="props.prependButtonText"
    type="button"
    [ngClass]="props.prependButtonClass || 'btn btn-outline-secondary'"
    (click)="onPrependButtonClick()">
    {{ props.prependButtonText }}
  </button>

  <input
    #phoneInput
    type="tel"
    class="form-control"
    [formlyAttributes]="field"
    [class.is-invalid]="showError"
    [placeholder]="props.placeholder || ''"
  />

  <span *ngIf="props.appendText" [ngClass]="props.appendTextClass || 'input-group-text'">{{
    props.appendText
  }}</span>

  <button
    *ngIf="props.appendButtonText"
    type="button"
    [ngClass]="props.appendButtonClass || 'btn btn-outline-secondary'"
    (click)="onAppendButtonClick()">
    {{ props.appendButtonText }}
  </button>
</div>